import type { SurveyPage } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { shouldIncludePageInPath } from '../visibility';
import { getNextVisiblePageIndex } from './getNextVisiblePageIndex';

export function findFirstVisiblePageIndex(
  pages: SurveyPage[],
  context: LogicContext
): number {
  if (pages.length === 0) return -1;

  const first = getNextVisiblePageIndex(pages, -1, context);
  return first < pages.length ? first : -1;
}

export function findLastVisiblePageIndex(
  pages: SurveyPage[],
  context: LogicContext
): number {
  for (let i = pages.length - 1; i >= 0; i -= 1) {
    const questions = pages[i]?.questions ?? [];
    if (questions.length > 0 && shouldIncludePageInPath(questions, context)) {
      return i;
    }
  }

  return -1;
}

export function resolveVisibleSkipTargetPageIndex(
  pages: SurveyPage[],
  targetPageIndex: number,
  context: LogicContext
): number {
  const questions = pages[targetPageIndex]?.questions ?? [];
  if (shouldIncludePageInPath(questions, context)) {
    return targetPageIndex;
  }

  return getNextVisiblePageIndex(pages, targetPageIndex, context);
}
